import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

export const loadScript = (src: string) => {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true
  s.src = src
  document.body.appendChild(s)
}

export const getCookieValue = (cookies: RequestCookie[], name: string): string | undefined => {
  const cookie = cookies.find((cookie) => cookie.name === name)
  return cookie ? cookie.value : undefined
}

export const onResizeEnd = (callback: () => void) => {
  let timeout: number | undefined = undefined

  const onResize = () => {
    clearTimeout(timeout)
    timeout = window.setTimeout(callback, 200)
  }

  window.addEventListener('resize', function () {
    onResize()
  })
}

export const debug = (message: string, data?: any) => {
  if (
    (window.localStorage && window.localStorage.ntvDebug === 'true') ||
    new URLSearchParams(document.location.search).get('ntvDebug') === 'true'
  )
    console.log(message, data)
}
